import React, { useEffect, useMemo, useState } from 'react';

import { Modal, Select, Tabs, Row, Col } from 'antd';

import { format } from 'date-fns';

import ptBR from 'date-fns/locale/pt-BR';

import Breadcumbs from '~/components/Breadcumbs';

import api from '~/services/api';

import { store } from '~/store';

import history from '~/services/history';

import {
  PageTitle,
  BreadcumbsContainer,
  BoxContent,
  BoxContentHeader,
  BoxList,
  BoxPagination,
  ModalContainer,
  ModalHeader,
  ModalFooter,
  ButtonModal,
} from './style';

import ButtonBack from '~/components/ButtonBack';
import DescricaoModal from './descricaoModal';
import DescricaoModalAnterior from './descricaoModalAnterior';
import RenderDescription from './renderDescription';

import { titlePage, tipoPageDescription } from './data/titlePage';

const { TabPane } = Tabs;

const ResumoEvento = props => {
  console.log('props', props);

  const [data, setData] = useState(null);

  useEffect(() => {
    const escapedValue = JSON.stringify(data);
    console.log('data', escapedValue);
  }, [data]);

  const [loading, setLoading] = useState(true);

  const { token } = store.getState().auth;

  const [noResults, setNoResults] = useState(false);

  const [pageCurrent, setPageCurrent] = useState(1);

  const [modalDescricao, setModalDescricao] = useState(false);

  const [modalData, setModalData] = useState();

  const [modalDataResponsavel, setModalDataResponsavel] = useState();

  const [tipoDeOperacaoModal, setIipoDeOperacaoModal] = useState();

  const [dataAudit, setDataAudit] = useState();

  const [idInstituicao, setIdInstituicao] = useState(null);

  const [tipoDeOperacao, setIipoDeOperacao] = useState(null);

  const [tipoPage, setTipoPage] = useState(null);

  const [dataOperacao, setDataOperacao] = useState(null);

  useEffect(() => {
    setDataOperacao(props?.location?.state?.data);
  }, [props]);

  const limit = 5;

  const getData = async props => {
    const type = props?.type;
    const order = props?.orderBy || '';
    const dir = props?.dir;

    const endPoint = dataOperacao.endpoint;

    try {
      const response = await api.get(`${endPoint}`, {
        headers: {
          Authorization: token,
        },
      });

      console.log('response', response);
      setData(response.data);

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (idInstituicao && tipoDeOperacao) {
      getData({ type: tipoDeOperacao });
    }
    setTipoPage(tipoPageDescription[tipoDeOperacao]);
  }, [tipoDeOperacao, idInstituicao]);

  useEffect(() => {
    setIdInstituicao(props.location.state.idInstituicao);
    setIipoDeOperacao(props.location.state.type);
  }, []);

  const descricaoOperacao = dados => {
    setModalData(dados);
    setModalDescricao(true);
  };

  const descricaoResponsavel = dados => {
    setModalDataResponsavel(dados);

    const { versaoAuditedId } = dados;
    getDataAudit(versaoAuditedId);
  };

  const fecharModal = () => {
    setModalDescricao(false);
    setTimeout(() => {
      setModalData(null);
    }, 200);
  };

  const tipoOperac = useMemo(() => {
    const tipo =
      (data?.depois?.tipo_operacao === 'UPDATE' && 'Atualização') ||
      (data?.depois?.tipo_operacao === 'INSERT' && 'Inclusão ') ||
      (data?.depois?.tipo_operacao === 'DELETE' && 'Exclusão');
    return tipo;
  }, [data]);

  return (
    <>
      <Breadcumbs path="resumo-de-eventos" pathTitle="Resumo de eventos" />
      <BreadcumbsContainer>
        <ButtonBack />
      </BreadcumbsContainer>

      <PageTitle>
        <div className="headerInline">
          <span>{tipoPage || ''}</span>
        </div>
      </PageTitle>

      <BoxContent>
        <BoxContentHeader>
          <Row>
            <Col span={5}>
              <span>Evento </span>
            </Col>

            <Col span={14}>
              <span className="descricaoHeader">Descrição</span>
            </Col>

            <Col span={5}>
              <div className="dataHoraHeader">
                <span>Data/Hora </span>
              </div>
            </Col>
          </Row>
        </BoxContentHeader>

        <BoxList>
          <Row>
            <Col span={5}>
              <div className="evento">
                <span>
                  {tipoOperac ||
                    (tipoDeOperacao === 'EXPORTACAO_DADOS' && 'Exportação')}
                </span>
              </div>
            </Col>

            <Col span={14}>
              <div className="evento descricao">
                <div className="descriptionGrid">
                  <div className="DataModal">
                    {data?.depois?.tipo_operacao === 'UPDATE' ? (
                      <Tabs
                        className="tabsContainer"
                        defaultActiveKey="1"
                        size="small"
                      >
                        <TabPane tab="Atual" key="1">
                          <div className="ModalBody">
                            <div>
                              {data?.depois && (
                                <RenderDescription
                                  tipoDeOperacao={tipoDeOperacao}
                                  modalData={data?.depois}
                                />
                              )}
                            </div>
                          </div>
                        </TabPane>
                        <TabPane tab="Antes" key="2">
                          <div className="ModalBody antes">
                            <div>
                              {data?.antes && (
                                <RenderDescription
                                  tipoDeOperacao={tipoDeOperacao}
                                  modalData={data?.antes}
                                />
                              )}
                            </div>
                          </div>
                        </TabPane>
                      </Tabs>
                    ) : (
                      <div className="ModalBody">
                        <div>
                          {data?.depois && (
                            <RenderDescription
                              tipoDeOperacao={tipoDeOperacao}
                              modalData={data?.depois}
                            />
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </Col>

            <Col span={5}>
              <div className="evento">
                {data?.depois?.tipo_operacao === 'INSERT' ? (
                  <span>
                    {data?.depois?.data?.dataCriacao &&
                      format(
                        new Date(`${data?.depois?.data?.dataCriacao}`),
                        'dd/MM/yyyy - HH:mm:ss',
                        {
                          locale: ptBR,
                        }
                      )}
                  </span>
                ) : (
                  <span>
                    {data?.depois?.data?.dataAtualizacao &&
                      format(
                        new Date(`${data?.depois?.data?.dataAtualizacao}`),
                        'dd/MM/yyyy - HH:mm:ss',
                        {
                          locale: ptBR,
                        }
                      )}
                  </span>
                )}
              </div>
            </Col>
          </Row>
        </BoxList>
      </BoxContent>
    </>
  );
};

export default ResumoEvento;
